import { BonusPoints } from './BonusPoints.js';

export class EmployeeBonusPoints {
    constructor(bonusPoints, orderTracking) {
        this.bonusPoints = bonusPoints;
        this.orderTracking = orderTracking;
    }

    registerRedeemClickHandler() {
        window.o_util.event.delegate('.order_js_basket_or_checkout', 'oc-property-change', '#or_js_bonusPoints__checkbox', async event => {
            if (this._ignoreNextChange) {
                this._ignoreNextChange = false;
                return;
            }
            const toBeRedeemed = event.detail.checked.current ? event.target.dataset.redeemable : '0';
            await this.bonusPoints.redeemBonusPointsAndReload(toBeRedeemed).catch(() => this._handleRedemptionError(event.target));
        });
    }

    _orderMessageFeature(errorMessageId) {
        return {
            id: 'order_message',
            name: 'OrderMessage',
            status: 'visible',
            labels: {
                order_ErrorMessage: [errorMessageId]
            }
        };
    }

    _handleRedemptionError(input) {
        this.bonusPoints.renderBonusPointRedemptionError();
        this._ignoreNextChange = true;
        input.checked = !input.checked;
        input.setAttribute('validation-message', ' ');

        this.orderTracking.submitEvent({
            name: 'submit',
            features: [this._orderMessageFeature(BonusPoints.REDEMPTION_ERROR_MESSAGE_ID + '.checkbox')]
        });
    }

    static initialize(settingsService) {
        if (!!settingsService && typeof settingsService.isEnabled === 'function') {
            const bonusPoints = new BonusPoints();
            const employeeBonusPoints = new EmployeeBonusPoints(bonusPoints, window.o_order.tracking);
            window.o_global.eventLoader.onReady(100, () => {
                employeeBonusPoints.registerRedeemClickHandler();
            });
        }
    }
}
